export default "__VITE_ASSET__DqmIHwRl__"